/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 팀 상세 내용
 * 버전 : 1.0
 * 파일명 : RightSection.tsx
 * 작성자 : 강동형
 * 작성일 : 2026-01-19
 * ================================================================
 * 수정일 : 2026-02-05, 담당지역 세로 스크롤 추가
 * ================================================================ */

import styled from 'styled-components'
import { ActionButton } from '../common/CommonStyled'
import { useAdTeamStore } from 'src/stores/AdTeamStore'
import { Icon_Medalion, Icon_People, Icon_Shield } from '../common/CommonIcons'
import RightTable from './RightTable'
import { useModalStore } from 'src/stores/ModalStore'
import ModalTitleModifyTeam from './ModalTitleModifyTeam'
import ModalContentModifyTeam from './ModalContentModifyTeam'

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    padding: 0px 11px;
    width: 100%;
    white-space: nowrap;
    height: 100%;
`
const LeftHeaderWrapper = styled.div`
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    position: relative;
    padding: 28px;
    border-bottom: 1px solid #D1D1D1;
    line-height: normal;
    margin-bottom: 4px;
`
const LeftHeaderButtonWrapper = styled.div`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    line-height: normal;
`
const TeamSummaryWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-content: center;
    gap: 20px;

    width: 100%;
    height:104px;
`
const TeamSummaryContainer = styled.div`
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;

    text-align: center;
    width: 100%;
    min-height:95px;
    max-height: 95px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.25);
`
const TeamSummaryHeader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;

    flex-shrink: 0;
    min-height: 48px;
    background-color: #30515B;;
    color: white;
    font-size: 18px;
    font-weight: 600;
`
const TeamSummaryFooter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    flex: 1;
    background-color: #fff;
    color: black;
    font-size: 20px;
    font-weight: 600;
    padding: 8px;
`
const AreaChip = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 6px 16px;
    border-radius: 24px;
    background-color: #EBEBEB;
    line-height: normal;
`

const RightSection = () => {
    const selectedTeam = useAdTeamStore((state)=>state.selectedTeam)
    const setField = useAdTeamStore((state)=>state.setField)
    const modalSetField = useModalStore((state)=>state.setField)

    const onClickModify = ()=>{
        modalSetField('type','CENTER')
        modalSetField('width','812px')
        modalSetField('padding','30px')
        setField('team_name',selectedTeam?.team_name)
        setField('team_areas',selectedTeam?.team_areas)
        setField('manager_uid',selectedTeam?.team_member.find((member)=>member.leader === 1)?.uid)
        setField('memberList',selectedTeam?.team_member)
        modalSetField('title', <ModalTitleModifyTeam/>)
        modalSetField('content',<ModalContentModifyTeam/>)
        modalSetField('open',true)
    }

  return (
    <PageWrapper>
        <LeftHeaderWrapper>
            {selectedTeam?.team_name} 팀 상세
            <LeftHeaderButtonWrapper>
                <ActionButton style={{width:'94px'}} onClick={onClickModify}>수정</ActionButton>
            </LeftHeaderButtonWrapper>
        </LeftHeaderWrapper>
        <TeamSummaryWrapper>
            <TeamSummaryContainer>
                <TeamSummaryHeader>
                    <Icon_Shield/>팀 명
                </TeamSummaryHeader>
                <TeamSummaryFooter>
                    {selectedTeam?.team_name}
                </TeamSummaryFooter>
            </TeamSummaryContainer>
            <TeamSummaryContainer>
                <TeamSummaryHeader>
                    <Icon_Medalion/>팀장
                </TeamSummaryHeader>
                <TeamSummaryFooter>
                    {selectedTeam?.manager_name ?? '-'}
                </TeamSummaryFooter>
            </TeamSummaryContainer>
            <TeamSummaryContainer>
                <TeamSummaryHeader>
                    <Icon_People/>인원
                </TeamSummaryHeader>
                <TeamSummaryFooter>
                    {selectedTeam?.team_count}
                </TeamSummaryFooter>
            </TeamSummaryContainer>
        </TeamSummaryWrapper>

        <TeamSummaryContainer style={{flexShrink: 0, maxHeight:'none'}}>
            <TeamSummaryHeader>
                담당 지역
            </TeamSummaryHeader>
            <TeamSummaryFooter style={{fontSize:'16px',fontWeight:500,gap:'6px',maxHeight:'calc(100vh - 500px)', overflowY:'auto'}}>
                {Object.entries(selectedTeam?.team_areas ?? {}).flatMap(([province, districts]:any) =>
                districts.map((district:any, idx:any) => (
                    <AreaChip
                    key={`${province}-${district}-${idx}`}
                    >
                        {`${province} ${district}`}
                    </AreaChip>
                )))}
            </TeamSummaryFooter>
        </TeamSummaryContainer>
        <RightTable PropsData={selectedTeam?.team_member ?? []}/>
    </PageWrapper>
  )
}

export default RightSection